module.exports = __webpack_public_path__ + "static/media/bni-2-horizontal.4425bdc3.png";